import React from 'react';

export interface CustomerLogoProps {
  logoUrl: string;
  alt?: string;
}

/**
 * Customer logo displayed in the top-right corner (Req 1.15).
 */
export const CustomerLogo: React.FC<CustomerLogoProps> = ({
  logoUrl,
  alt = 'Capoeira Sempre Senzala',
}) => {
  if (!logoUrl) return null;

  return (
    <div style={styles.container}>
      <img
        src={logoUrl}
        alt={alt}
        style={styles.logo}
        onError={(e) => {
          // Hide logo if it fails to load
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    zIndex: 10,
  },
  logo: {
    maxWidth: '80px',
    maxHeight: '40px',
    objectFit: 'contain',
    opacity: 0.9,
    filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.5))',
  },
};
